import type { AfcSubmissionCandidate, Candidate } from '@axiom/validation';

type PropsType = {
  candidate?: Partial<Candidate | AfcSubmissionCandidate>;
  submissionDescription?: string | null;
};

export class SubmissionCandidateModel {
  props: PropsType = { candidate: {} };

  constructor(props: PropsType = { candidate: {} }) {
    this.props = props;
  }

  calculatedDescription() {
    return (
      (this.props.submissionDescription?.trim() ?? '') ||
      this.props.candidate?.candidateSummary ||
      ''
    ).trim();
  }

  /**
   * The Textarea `formatting` mode that matches whichever field
   * `calculatedDescription` resolved to. `submissionDescription` is stored in
   * the `modern` format (MIE-736 backfill); `candidateSummary` was not migrated
   * and remains `legacy`. Mirror the same branch selection as
   * `calculatedDescription` so the resolved text is always rendered with the
   * format it is stored in.
   */
  calculatedDescriptionFormatting(): 'legacy' | 'modern' {
    return this.props.submissionDescription?.trim() ? 'modern' : 'legacy';
  }

  calculatedAddress() {
    return [
      this.props.candidate?.addressCity,
      this.props.candidate?.addressState,
      this.props.candidate?.addressCountry,
    ]
      .filter(Boolean)
      .join(', ');
  }
}
